import {
  CLINIC_NAMES,
  DEFAULT_PROVIDER_NOTES_TITLE,
  EVOKE_ACTIVE,
  USER_ROLES,
} from "static/constants";
import { addToDate } from "./date";
import { DATE_FORMAT } from "static/date";
import {
  THIRTY_ONE_DAY_BILLING_CODES_FOR_LETTER,
  NINETY_ONE_DAY_BILLING_CODES_FOR_LETTER,
} from "static/letter";

// TODO: Needs confirmation for input text valid
// checks for digits, 'year', 'years', month, months, or '%' in the string
export const isValidBatteryLife = (batteryLife) => {
  return (
    typeof batteryLife === "string" &&
    /(\d+\s*year|\d+\s*years|\d+\s*month|\d+\s*months|\d+%)/i.test(batteryLife)
  );
};

export const getBatteryLife = (notes) => {
  const batteryInformation =
    notes?.find((noteData) => noteData?.note === "Battery") || {};

  const batteryLife = batteryInformation?.content?.[0]?.description || null;
  // const hasValidBatteryLife = isValidBatteryLife(batteryLife);

  return batteryLife;
};

export const generateNextSendCycleByBillingCode = (billingCode) => {
  const billingMap = {
    31: THIRTY_ONE_DAY_BILLING_CODES_FOR_LETTER,
    91: NINETY_ONE_DAY_BILLING_CODES_FOR_LETTER,
  };

  for (const [days, codes] of Object.entries(billingMap)) {
    if (codes.includes(billingCode)) return Number(days);
  }

  return null;
};

export const generateNextSendByBillingInformation = (
  billingCode,
  billingDate
) => {
  const cycleDays = generateNextSendCycleByBillingCode(billingCode);

  return cycleDays && billingDate
    ? addToDate(billingDate, cycleDays).format(DATE_FORMAT.DEFAULT)
    : null;
};

export const isEligibleForLetterSend = ({
  reportTab,
  billableDate,
  report,
}) => {
  const { account, billing_code: billingCode } = report || {};
  const benchmarkId = report?.patient?.benchmark_id;
  const idtf = report?.patient?.information?.idtf;
  const hasStatusLetter = report?.patient?.information?.status_letter;

  const cycleDays = generateNextSendCycleByBillingCode(billingCode);

  return (
    hasStatusLetter &&
    account === CLINIC_NAMES.PUEBLO &&
    reportTab === EVOKE_ACTIVE &&
    Boolean(billableDate) &&
    Boolean(cycleDays) &&
    Boolean(benchmarkId) &&
    idtf
  );
};

export const shouldSendLetterWithReportNote = ({
  reportTab,
  billableDate,
  report,
}) => {
  const isEligible = isEligibleForLetterSend({
    reportTab,
    billableDate,
    report,
  });

  if (!isEligible) return false;

  return {
    hasLetterSendEligibility: isEligible,
    isValidForSendingLetter: isEligible,
  };
};

export const checkUserAuditAccess = (user, data) => {
  return (
    user?.is_auditor &&
    (data?.evk_processed || data?.evk_archived) &&
    [USER_ROLES.ADMIN]?.includes(user?.role)
  );
};

export const getProviderNoteTitle = (accountsMapper, account) =>
  accountsMapper?.[account]?.settings?.provider_notes_title ||
  DEFAULT_PROVIDER_NOTES_TITLE;
